import { z } from 'zod';
import {
  AvailableRateSchema,
  RateSchema,
  RoomRateSchema,
  RateRoomSchema,
  SingleAvailableRateSchema,
  StaticRateSchema,
} from './schemas';

export type StaticRate = z.infer<typeof StaticRateSchema>;
export type AvailableRate = z.infer<typeof AvailableRateSchema>;
export type SingleAvailableRate = z.infer<typeof SingleAvailableRateSchema>;
export type RoomRate = z.infer<typeof RoomRateSchema>;
export type RateRoom = z.infer<typeof RateRoomSchema>;
export type Rate = z.infer<typeof RateSchema>;

export enum RatesFilterType {
  SPA_STAYS = 'spa-stays',
}
